import React from 'react';
import PropTypes from 'prop-types';

import Textlink from '../link/Textlink';

const TopLineTitle = (props) => {
  const {
    name,
    area,
    onClickDetailLink,
    hideDetailLink,
  } = props;

  return (
    <div className="TopLineTitle">
      <div className="title">
        <span className="mainTitle">{name}</span>
        <span className="subTitle">{area}</span>
      </div>
      {!hideDetailLink && (
        <div className="link">
          <Textlink onClick={onClickDetailLink}>施設詳細</Textlink>
        </div>
      )}
    </div>
  );

};

TopLineTitle.defaultProps = {
};

TopLineTitle.propTypes = {
  name: PropTypes.string,
  area: PropTypes.string,
  onClickDetailLink: PropTypes.func,
  withoutLink: PropTypes.bool,
  hideDetailLink: PropTypes.bool,
};

export default TopLineTitle;
